import { nextTick, type Ref } from 'vue'
import { createI18n, type I18n } from 'vue-i18n'
import { useLocalStorage } from '@vueuse/core'
import axios from 'axios'

export const LOADED_LOCALES: string[] = []
export const SUPPORT_LOCALES: string[] = ['de', 'en']
export type I18nType = I18n<Record<string, unknown>, Record<string, unknown>, Record<string, unknown>, object, false>
export const setupI18n = async (): Promise<I18nType> => {
  const i18n: I18nType = createI18n({
    legacy: false,
    locale: useLocalStorage('locale', 'de').value, // set locale
    fallbackLocale: 'en', // set fallback locale
    globalInjection: true,
    missingWarn: false
  })
  await setI18nLanguage(i18n, i18n.global.locale)
  return i18n
}

export async function setI18nLanguage(i18n: I18nType, locale: Ref<string | object>) {
  if (typeof locale.value !== 'string') return

  i18n.global.locale.value = locale.value

  axios.defaults.headers.common['Accept-Language'] = locale.value
  // if (!SUPPORT_LOCALES.includes(locale.value)) locale.value = i18n.global.fallbackLocale.value
  await loadLocaleMessages(i18n, locale.value)
  document.querySelector('html')?.setAttribute('lang', locale.value)
}

export async function loadLocaleMessages(i18n: I18nType, locale: string) {
  if (LOADED_LOCALES.includes(locale)) return
  // load locale messages with dynamic import
  const messages = await import(/* webpackChunkName: "locale-[request]" */ `@/i18n/${locale}.json`)

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default)
  LOADED_LOCALES.push(locale)
  return nextTick()
}
